import { Box, HStack } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
import { WEB_APP_CTA_MAX_WIDTH } from 'utils/constants';

export const displayValueStyleProps = () => ({
  background: 'transparent',
  minWidth: 5,
  width: 5,
  _text: {
    fontSize: 18,
  },
});

export const incrementorStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  padding: 1,
  borderRadius: 20,
  borderWidth: 1,
  margin: 0.5,
  borderColor: getDesignToken(disabled ? 'icon-disabled' : 'icon-default'),
  _icon: {
    color: getDesignToken(disabled ? 'icon-disabled' : 'icon-default'),
    size: 6,
  },
});

export const ActionsWrapper = Box.withConfig({
  width: 'full',
  paddingX: { base: '$4', md: 0 },
  flexDirection: 'row',
  justifyContent: 'space-between',
  maxWidth: WEB_APP_CTA_MAX_WIDTH,
});

// Footer Styles
export const BoxChild = Box.withConfig<{ lastChild: boolean; spaces?: number }>(p => ({
  alignItems: 'center',
  justifyContent: 'center',
  flex: p.spaces || 1,
  marginRight: p.lastChild ? 0 : 4,
}));

export const FooterWrapper = HStack.withConfig({
  borderTopWidth: 1,
  borderTopColor: primitive.$blackOpacity4,
  safeAreaBottom: true,
  width: 'full',
  background: getDesignToken('background-pattern'),
  paddingY: '$6',
  _ios: {
    paddingY: 0,
    paddingTop: '$6',
  },
  _android: {
    paddingY: 0,
    paddingTop: '$6',
    marginBottom: -5,
  },
});
